import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PropertiesDetailsViewComponent } from './properties-details-view.component';
import { GetImageSrcPipe } from 'app/pipes/get-image-src.pipe';
import { FuseSharedModule } from '@fuse/shared.module';
import { FuseSidebarModule } from '@fuse/components';
import { LightboxModule } from 'ngx-lightbox';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialogModule } from '@angular/material/dialog';
import { MatToolbarModule } from '@angular/material/toolbar';

@NgModule({
    declarations: [PropertiesDetailsViewComponent],
    imports: [
        CommonModule,
        FuseSharedModule,
        MatButtonModule,
        MatIconModule,
        MatProgressSpinnerModule,
        MatTooltipModule,
        FuseSidebarModule,
        LightboxModule,
        MatDialogModule,
        MatToolbarModule
    ],
    providers: [
        GetImageSrcPipe
    ],
    exports: [PropertiesDetailsViewComponent]
})
export class PropertiesDetailsViewModule { }
